(() => {
  const root = document.documentElement;
  const key = 'warra-studio-appearance';
  const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  let manual = false;

  function preference() {
    try {
      const value = localStorage.getItem(key);
      if (value === 'dark' || value === 'light') return value;
    } catch {}
    return null;
  }

  function syncButtons() {
    document.querySelectorAll('[data-studio-appearance-toggle]').forEach(button => {
      button.setAttribute('aria-checked', String(root.dataset.studioAppearance === 'dark'));
      button.hidden = false;
    });
  }

  function apply(value) {
    root.dataset.studioAppearance = value;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = value === 'dark' ? '#000000' : '#ffffff';
    syncButtons();
  }

  function restore() {
    const saved = preference();
    manual = saved !== null;
    apply(saved || (media?.matches ? 'dark' : 'light'));
  }

  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-studio-appearance-toggle]') : null;
    if (!button) return;
    const next = root.dataset.studioAppearance === 'dark' ? 'light' : 'dark';
    manual = true;
    apply(next);
    try { localStorage.setItem(key, next); } catch {}
  });

  media?.addEventListener('change', event => {
    if (!manual) apply(event.matches ? 'dark' : 'light');
  });
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) restore();
  });
  window.addEventListener('pageshow', restore);
  document.addEventListener('shopify:section:load', syncButtons);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, { once: true });
  else restore();
})();
